import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SegmentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"segment"}/>
}
